import { render, staticRenderFns } from "./TournamentEndedLabel.vue?vue&type=template&id=6fd2bdfe"
import script from "./TournamentEndedLabel.vue?vue&type=script&lang=js"
export * from "./TournamentEndedLabel.vue?vue&type=script&lang=js"
import style0 from "./TournamentEndedLabel.vue?vue&type=style&index=0&id=6fd2bdfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports